import React from "react";
import ClayLoadingIndicator from "@clayui/loading-indicator";

function Loading({ isSmall }) {
  return isSmall ? (
    <ClayLoadingIndicator small />
  ) : (
    <div id="loading">
      <ClayLoadingIndicator className="spin-loader" size="md" />
    </div>
  );
}

export default Loading;
